<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/register.jpg" alt="register" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title">
                                    <h4 class="mb-4">Create Account</h4>
                                    <p>Fill the below form to create a new account.</p>
                                </div>
                                <div class="clearfix">
                                    <vs-input
                                        data-vv-validate-on="blur"
                                        name="email"
                                        type="email"
                                        label-placeholder="Email"
                                        placeholder="Email"
                                        v-model="user.email"
                                        class="w-full mt-6" />
                                    <vs-input
                                        data-vv-validate-on="blur"
                                        label-placeholder="Company"
                                        name="company"
                                        placeholder="Company"
                                        v-model="user.company"
                                        class="w-full" />
                                    <vs-input
                                        data-vv-validate-on="blur"
                                        label-placeholder="First Name"
                                        name="first_name"
                                        placeholder="First Name"
                                        v-model="user.first_name"
                                        class="w-full" />
                                    <vs-input
                                        data-vv-validate-on="blur"
                                        label-placeholder="Last Name"
                                        name="last_name"
                                        placeholder="last Name"
                                        v-model="user.last_name"
                                        class="w-full" />
                                    <vs-input
                                        ref="password"
                                        type="password"
                                        data-vv-validate-on="blur"
                                        name="password"
                                        label-placeholder="Password"
                                        placeholder="Password"
                                        v-model="user.password"
                                        class="w-full mt-6" />
                                    <vs-input
                                        type="password"
                                        data-vv-validate-on="blur"
                                        data-vv-as="password"
                                        name="confirm_password"
                                        label-placeholder="Confirm Password"
                                        placeholder="Confirm Password"
                                        v-model="user.confirm_password"
                                        class="w-full mt-6" />
                                    <vs-input
                                        type="tel"
                                        minlength=11
                                        maxlength=15
                                        data-vv-validate-on="blur"
                                        data-vv-as="Phone"
                                        name="Phone"
                                        label-placeholder="Phone"
                                        placeholder="Phone (01xxxxxxxxx) or (201xxxxxxxxx) or (+201xxxxxxxxx)"
                                        v-model="user.mobile"
                                        class="w-full mt-6" />
                                    <vs-button  type="border" to="/login" class="mt-6">Login</vs-button>
                                    <vs-button class="float-right mt-6" @click="register($vs)" >Register</vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { nestedObjectToArray } from "../../utils/requestHelpers"
export default {
    data() {
        return {
            user:
            {
                first_name: '',
                last_name: '',
                company: '',
                mobile: '',
                email: '',
                password: '',
                confirm_password: '',
                // read fron .env i need suggestions 
                claims: process.env.VUE_APP_USER_Claims.split(","),
                username: '',
            },
            errorsArray: []
        }
    },
    methods:
    {
        register(item) {
            this.user.username = this.user.email
            this.$vs.loading()
            axios.post(process.env.VUE_APP_API + "users/", this.user)
            .then(() => {
                this.$vs.loading.close();
                item.notify({
                    title: 'Success',
                    position: 'top-right',
                    text: 'Success to register Maestro',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check'})
                this.$router.push('/login');
            })
            .catch(error => {
                this.$vs.loading.close();
                var errorsArray = nestedObjectToArray(error.response.data);
                errorsArray.forEach(errorMessage => {
                item.notify({
                    title: 'Error',
                    position: 'top-right',
                    text: errorMessage,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'})
                });
                return;
            });
        }
    }
}
</script>
